export enum CustomSource {
  Osa = "Osa",
  SimplifiedOsa = "SimplifiedOsa",
  Hla = "Hla",
  PlannedTrajectory = "PlannedTrajectory",
  PendingCoordChanges = "PendingCoordChanges",
  CopyNodes = "CopyNodes",
  Screen = "Screen",
  Projects = "Projects",
  StreetView = "StreetView",
  QueryInfrastructure = "QueryInfrastructure",
}
